'use-strict';

import { ILocationService, IScope } from 'angular';
import { SalesAPIService } from '../../shared/api/sales-api.service';
import { InterfaceService } from '../../shared/interface/interface.service';
import { PossibleImports } from '../../src/app/@shared-types/api';
import LogService from '../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../ui-components/toast/toast.service';

interface ImportScope extends IScope {
  vehicleToImport: {
    vin?: string,
  },
  error: boolean,
  importOptions: PossibleImports | null,
  importOptionsCount: number,
  importOptionsCountText: string,
  preloader: boolean,
  importing: boolean,
  searchVin: () => void,
  importSchwackeVehicle: () => void,
  importDATVehicle: () => void,
  importUSVehicle: () => void,
  importLocoSoftDbVehicle: () => void,
}

/* @ngInject */
export default function SalesImportIntroController(
  $scope: ImportScope,
  $routeParams: angular.route.IRouteParamsService,
  salesApiService: SalesAPIService,
  interfaceService: InterfaceService,
  logService: LogService,
  toastService: ToastService,
  $location: ILocationService,
): void {
  $scope.vehicleToImport = {
    vin: '',
  };
  $scope.error = false;
  $scope.importOptions = null;
  $scope.preloader = false;
  $scope.importing = false;

  const init = () => {
    if ($routeParams.vin !== undefined) {
      $scope.vehicleToImport.vin = $routeParams.vin;
    }
  };

  /**
   * User wants to import a car into Autoboard.
   * We ask the API server to offer all options to do so and display them
   * accordingly.
   */
  $scope.searchVin = () => {
    $scope.error = false;
    $scope.importOptionsCount = 0;
    if ($scope.vehicleToImport.vin?.length !== 17) {
      $scope.error = true;
      return;
    }

    $scope.importing = true;
    init();
    $scope.preloader = true;

    salesApiService.getImportOptions($scope.vehicleToImport.vin)
      .then((importOptions) => {
        $scope.importOptions = importOptions;
        $scope.importing = false;
        $scope.preloader = false;

        const possible = (Object.values(importOptions.apis as any) as boolean[]).filter((s) => s);
        $scope.importOptionsCount = possible.length + 1;
        $scope.importOptionsCountText = '1 Option';
        if ($scope.importOptionsCount > 1) $scope.importOptionsCountText = `${$scope.importOptionsCount} Optionen`;

        console.log($scope.importOptions);

        interfaceService.applyScope($scope);
      })
      .catch((e) => {
        $scope.preloader = false;
        $scope.importing = false;
        logService.error(e);
      });
  };

  $scope.importSchwackeVehicle = () => {
    if (!$scope.vehicleToImport.vin) return;
    $scope.importing = true;
    salesApiService.importVehicleFromSchwacke($scope.vehicleToImport.vin)
      .then((vehicleId) => {
        $location.path(`/vehicles/edit/${vehicleId}`).search('success', 'schwacke');
      })
      .catch((e) => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Import');
        $scope.importing = false;
        logService.error(e);
      });
  };

  $scope.importDATVehicle = () => {
    if (!$scope.vehicleToImport.vin) return;
    $scope.importing = true;
    salesApiService.importVehicleFromDAT($scope.vehicleToImport.vin)
      .then((vehicleId) => {
        $location.path(`/vehicles/edit/${vehicleId}`).search('success', 'dat');
      })
      .catch((e) => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Import');
        $scope.importing = false;
        logService.error(e);
      });
  };

  $scope.importUSVehicle = () => {
    if (!$scope.vehicleToImport.vin) return;
    $scope.importing = true;
    salesApiService.importUSVehicle($scope.vehicleToImport.vin)
      .then((vehicleId) => {
        $location.path(`/vehicles/edit/${vehicleId}`).search('success', 'us');
      })
      .catch((e) => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Import');
        $scope.importing = false;
        logService.error(e);
      });
  };

  $scope.importLocoSoftDbVehicle = () => {
    if (!$scope.vehicleToImport.vin) return;
    $scope.importing = true;
    salesApiService.importLocoSoftDbVehicle($scope.vehicleToImport.vin)
      .then((vehicleId) => {
        $location.path(`/vehicles/edit/${vehicleId}`).search('success', 'loco-soft');
      })
      .catch((e) => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Import');
        $scope.importing = false;
        logService.error(e);
      });
  };

  init();
}
